/**
 * Unified interface for canceling requests for client and server. Client implementation
 */
export class CancelRequestToken {
    constructor() {
        this._source = new AbortController();
        this._token = this._source.signal;
    }
    get token() {
        return this._token;
    }
    cancel() {
        this._source.abort();
    }
}
